/**
 * Resolve a deep-link ?page= query value to a 1-based script page index.
 * Matches pagination: label lookup first, then numeric index fallback.
 * @param {string|number|null|undefined} pageParam
 * @param {Array<{ name?: string }>|null|undefined} pdfPageNumbers
 * @returns {number|null}
 */
export function resolvePageIndexFromDeepLink(pageParam, pdfPageNumbers) {
    if (pageParam == null || pageParam === '') {
        return null;
    }
    const raw = String(pageParam).trim();
    if (!raw) {
        return null;
    }
    const pages = Array.isArray(pdfPageNumbers) ? pdfPageNumbers : [];
    if (pages.length === 0) {
        return null;
    }

    const byName = pages.findIndex(
        item => String((item && item.name) || '').trim() === raw
    );
    if (byName !== -1) {
        return byName + 1;
    }

    const asNumber = Number(raw);
    if (
        Number.isInteger(asNumber) &&
        asNumber > 0 &&
        asNumber <= pages.length
    ) {
        return asNumber;
    }

    return null;
}

export default {
    resolvePageIndexFromDeepLink
};


// WEBPACK FOOTER //
// ./src/lib/resolve-page-index.js